export default defineNuxtPlugin({
   name: 'customer-io',
   dependsOn: ['acquisition-entry'],
   setup() {
      const config = useRuntimeConfig();
      const siteId = typeof config.public.CUSTOMER_IO_SITE_ID === 'string'
         ? config.public.CUSTOMER_IO_SITE_ID.trim() : '';
      if (!siteId) return;
      let apiHost;
      try {
         apiHost = new URL(config.public.API_BASE_URL).hostname.toLowerCase().replace(/\.$/, '');
      } catch {
         return;
      }
      // Local delivery belongs to the backend's guarded fixture test mode.
      if (apiHost === 'localhost' || apiHost.endsWith('.localhost') ||
         /^127\./.test(apiHost) || apiHost === '[::1]' || apiHost === '::1') return;
      // Initialize Customer.io script
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      script.id = 'cio-tracker';
      script.setAttribute('data-site-id', siteId);
      script.src = 'https://assets.customer.io/assets/track-eu.js';
      script.setAttribute('data-auto-track-page', 'false');
      const existingScript = document.getElementsByTagName('script')[0];
      existingScript.parentNode.insertBefore(script, existingScript);

      // Define the `_cio` array with required methods
      window._cio = window._cio || [];
      const methods = ['load', 'identify', 'sidentify', 'track', 'page', 'reset'];
      methods.forEach((method) => {
         window._cio[method] = (...args) => {
            window._cio.push([method, ...args]);
         };
      });
   },
});
